<template>
  <div class="disabled-overlay">
    <div class="disabled-overlay-inner">
      <h2>{{ $t('locked.account_locked') }}</h2>
      <h5>{{ $t('locked.renew_subscription') }}</h5>
      <br />
      <h6><a href="mailto:racuni@blackblox.si">racuni@blackblox.si</a> | <span class="nowrap">01/236 48 80</span></h6>
    </div>
  </div>
</template>

<script>
export default {
    name: 'Locked'
};
</script>

<style scoped lang="scss">
  .disabled-overlay {
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: 1600;
    text-align: center;
    top: 0;
    background-color: rgba(255, 255, 255, 0.85);
    color: $panel-black;
    overflow: hidden;
  }

  .disabled-overlay-inner {
    margin: 15em 2em 0;
  }

  .disabled-overlay-inner h2 {
    font-weight: bold;
    font-size: 2em;
    line-height: 1em;
    margin-bottom: 0.25em;
  }

  .disabled-overlay-inner h5 {
    font-size: 1.5em;
    line-height: 1em;
  }
</style>
